import { QuantitySelectorUpdateEvent } from './events.js';

class QuantitySelectorComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('change', this.handleChange);
    this.updateButtons();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('change', this.handleChange);
  }

  get input() {
    return this.querySelector('input[type="number"]');
  }

  get cartLine() {
    return this.dataset.cartLine || this.input?.dataset.line || null;
  }

  handleClick = (event) => {
    const button = event.target.closest('[data-quantity-step]');
    if (!button || !this.contains(button)) return;

    const input = this.input;
    if (!(input instanceof HTMLInputElement)) return;

    event.preventDefault();

    const step = Number(button.dataset.quantityStep || input.step || 1);
    const nextValue = this.clamp(Number(input.value || input.min || 1) + step);
    this.setValue(nextValue);
  };

  handleChange = (event) => {
    if (event.target !== this.input) return;
    this.setValue(this.clamp(Number(this.input.value || this.input.min || 1)));
  };

  clamp(value) {
    const input = this.input;
    if (!(input instanceof HTMLInputElement)) return value;

    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;
    return Math.min(max, Math.max(min, value));
  }

  setValue(value) {
    const input = this.input;
    if (!(input instanceof HTMLInputElement)) return;

    input.value = String(value);
    this.updateButtons();

    if (this.cartLine) {
      this.dispatchEvent(new QuantitySelectorUpdateEvent(value, this.cartLine, this.id || this.closest('[id]')?.id || 'quantity-selector'));
    }
  }

  updateButtons() {
    const input = this.input;
    if (!(input instanceof HTMLInputElement)) return;

    const value = Number(input.value || input.min || 1);
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;

    this.querySelectorAll('[data-quantity-step]').forEach((button) => {
      const nextValue = value + Number(button.dataset.quantityStep || 1);
      button.toggleAttribute('disabled', nextValue < min || nextValue > max);
    });
  }
}

if (!customElements.get('quantity-selector-component')) {
  customElements.define('quantity-selector-component', QuantitySelectorComponent);
}

export { QuantitySelectorComponent };
